import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default from 'react';
import { api, login } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import '../../../../../lazy-image/legacy-lazy-image/index.js';
import { CircleLazyImage } from '../../../../../lazy-image/lazy-image/index.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { logout } from '../../../api/user-center.js';
import { useHeaderContext } from '../../../context.js';

var MENU_MAP = [{
  key: 'homepage',
  name: '我的主页',
  url: "".concat(api.MISSEVAN_SITE_MAIN)
}, {
  key: 'purchased',
  name: '我的已购',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/purchased")
}, {
  key: 'message',
  name: '消息中心',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/comment")
}, {
  key: 'wallet',
  name: '我的钱包',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/wallet")
}, {
  key: 'account',
  name: '账号设置',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/account")
}, {
  key: 'task',
  name: '鱼干任务',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/task")
}, {
  key: 'logout',
  name: '退出'
}];
var UserBox = function UserBox() {
  var _useHeaderContext = useHeaderContext(),
      showGuestBox = _useHeaderContext.showGuestBox,
      loading = _useHeaderContext.loading,
      user = _useHeaderContext.user;

  var handleLoginClick = function handleLoginClick() {
    login.gotoLogin();
  };

  var handleLogoutClick = function handleLogoutClick() {
    logout();
  };

  var TUserBox = function TUserBox() {
    var _context;

    if (!user) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(prependPrefix('menu'), prependPrefix('user-box'))
    }, /*#__PURE__*/React__default.createElement("a", {
      className: prependPrefix('user'),
      target: "_blank",
      href: _concatInstanceProperty(_context = "".concat(api.MISSEVAN_SITE_MAIN, "/")).call(_context, user.id)
    }, /*#__PURE__*/React__default.createElement(CircleLazyImage, {
      src: user.boardiconurl2,
      className: prependPrefix('avatar')
    }), /*#__PURE__*/React__default.createElement("span", {
      className: prependPrefix('username')
    }, user.username)), /*#__PURE__*/React__default.createElement("ul", {
      className: prependPrefix('popup')
    }, _mapInstanceProperty(MENU_MAP).call(MENU_MAP, function (_ref) {
      var _context2;

      var key = _ref.key,
          name = _ref.name,
          url = _ref.url;
      return /*#__PURE__*/React__default.createElement("li", {
        className: classNames(prependPrefix('item'), key),
        key: name
      }, key === 'logout' ? /*#__PURE__*/React__default.createElement("button", {
        onClick: handleLogoutClick
      }, /*#__PURE__*/React__default.createElement("i", null), name) :
      /*#__PURE__*/
      // TODO: 通过 /mperson/getUnreadMessageNumber 接口的返回显示消息中心未读消息数量
      React__default.createElement("a", {
        href: key === 'homepage' ? _concatInstanceProperty(_context2 = "".concat(url, "/")).call(_context2, user.id) : url,
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement("i", null), name));
    })));
  };

  var GuestBox = function GuestBox() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(prependPrefix('menu'), prependPrefix('user-box'))
    }, /*#__PURE__*/React__default.createElement("a", {
      onClick: handleLoginClick
    }, "\u767B\u5F55 / \u6CE8\u518C"));
  };

  if (loading || !user && !showGuestBox) {
    return null;
  }

  return user ? /*#__PURE__*/React__default.createElement(TUserBox, null) : /*#__PURE__*/React__default.createElement(GuestBox, null);
};

export { UserBox };
